import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=ef5b1708"
import script from "./Offset.vue?vue&type=script&lang=js"
export * from "./Offset.vue?vue&type=script&lang=js"
import style0 from "./Offset.vue?vue&type=style&index=0&id=ef5b1708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports